// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vanilluxe: PokeData = {
  "id": 584,
  "name": "vanilluxe",
  "height": 13,
  "weight": 575,
  "base_experience": 241,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "mist",
    "ice-beam",
    "blizzard",
    "harden",
    "acid-armor",
    "icy-wind",
    "mirror-coat",
    "uproar",
    "hail",
    "taunt",
    "astonish",
    "weather-ball",
    "sheer-cold",
    "icicle-spear",
    "avalanche",
    "mirror-shot",
    "icicle-crash",
    "freeze-dry"
  ],
  "moves": [
    "blizzard",
    "sheer-cold",
    "avalanche",
    "aurora-veil",
    "chilly-reception",
    "icicle-dagger",
    "ice-punch",
    "ice-shard",
    "hailstorm",
    "ice-wave",
    "ice-fang"
  ],
  "evolution_chain": {
    "id": 296,
    "item": null,
    "species": [
      {
        "name": "vanillite",
        "order": 583,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vanillish",
        "order": 584,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 582,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vanilluxe",
        "order": 585,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 583,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 47,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 117,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
